import React, {Component} from 'react';
import {connect} from 'react-redux';

class ChatUserSearchItem extends Component {
  render() {
    return (
      <div>
        {this.props.user.nick}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

export default ChatUserSearchItem;